<template>
  <div class="client-listing-detail-fluid">
    <div class="">
      <div class="client-listing-detail" style="padding: 10px 0px;">
        <!-- <h5 class="mt-5">個別連絡一覧</h5> -->
        <div class="template-button-block">
          <TemplateListButton
            :type="'button'"
            :btnClass="'btn message-template me-5'"
            :label="'テンプレート一覧'"
            @click="openReplyTemplate"
          />
        </div>
        <!-- <div class="search-div" v-if="!isReceivedList">
          <p @click="showSearchModal" style="cursor: pointer;">
            送信一覧検索 ＋
          </p>
          <ContactSearch v-if="searchModal" />
        </div> -->
        <MessageTemplate ref="templateModal" />
        <div class="col-sm-12 col-12 mb-4 p-0">
          <div class="navbar">
            <router-link
              v-for="link in navbarLinks"
              :key="link.path"
              :to="link.path"
              class="navbar-item"
              :class="{ active: isActiveLink(link) }"
            >
              <p :class="{ activetext: isActiveLink(link) }">
                {{ link.label }}
              </p>
            </router-link>
          </div>
        </div>
        <div class="toggle-div" v-show="isReceivedList">
          <div class="toggle-button">
            <span class="toggle-label">全回答表示</span>
            <ToggleButton
              :labels="false"
              :value="showHidden"
              @change="toggleHide()"
              class="mb-0"
              :height="24"
              :width="48"
            />
          </div>

          <!-- <div class="extra-height" v-show="!isReceivedList" style="height: 30px;"></div> -->
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import ContactSearch from './ContactSearch.vue';
import MessageTemplateModal from '../MessageTemplate/MessageTemplateModal.vue';
import MessageTemplate from '../MessageTemplate/MessageTemplate.vue';
import TemplateListButton from '@/components/common/TemplateListButton.vue';
export default {
  name: 'ContactLists',
  data() {
    return {
      showReplyTemplate: false,
    };
  },
  components: {
    ContactSearch,
    MessageTemplateModal,
    MessageTemplate,
    TemplateListButton,
  },
  computed: {
    ...mapGetters({
      showHidden: 'getShowHidden',
      currentUser: 'getCurrentUser',
      searchModal: 'getSearchModal',
    }),
    navbarLinks() {
      const links = [
        { path: '/contact-list/received-list', label: '回答一覧' },
        { path: '/contact-list/sent-list', label: '送信一覧' },
      ];
      return links;
    },
    isReceivedList() {
      // console.log(this.$route.path == '/contact-list/received-list')
      if (this.$route.path === '/contact-list/received-list') {
        return true;
      } else {
        return false;
      }
    },
    hasContactAuthority() {
      return (
        this.currentUser &&
        this.currentUser.companyContactAuthority
      );
    },
  },
  methods: {
    ...mapMutations(['toggleHiddenContacts', 'toggleSearchModal']),
    onHideModal() {
      this.showReplyTemplate = false;
    },
    openReplyTemplate() {
      this.$refs.templateModal.show();
    },
    toggleHide() {
      this.toggleHiddenContacts();
      // console.log(this.showHidden);
    },
    isCurrentRoute(path) {
      // console.log(path);
      return this.$route.path === path;
    },
    isActiveLink(link) {
      const currentPath = this.$route.path;
      // console.log(link.path)
      return currentPath.startsWith(link.path);
    },
  },
  mounted() {
    this.changeBodyToWhite();
    const firstLink = this.navbarLinks[0];
    if (this.$route.path === '/contact-list') {
      this.$router.push(firstLink);
    }
  },
  watch: {
    currentUser(newVal) {
      if (newVal !== null) {
        if (!this.hasContactAuthority) {
          return this.$router.push('/applicant');
        }
      }
    },
  },
};
</script>

<style scoped>
.search-div {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  font-size: 18px;
  color: #787878;
}
.navbar {
  display: flex;
  justify-content: center;
  gap: 0px;
  padding: 0px !important;
  margin-bottom: 20px;
}

.navbar-item {
  color: #3c3c3c;
  text-decoration: none;
  font-weight: 600;
  background: #fff;
  border: 1px solid #e4e7ea;
  border-radius: 0px;
  padding: 0px 120px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s;
  min-width: 300px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.navbar-item p {
  margin: 0;
  padding: 0;
  line-height: 1;
}

.navbar-item:hover {
  opacity: 0.8;
}

.active {
  background: #036d6c;
  color: #fff;
  font-weight: bold;
}

.activetext {
  color: inherit;
}

.template-button-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  margin-bottom: 15px;
  padding-right:130px;
}

.message-template {
  width: 235px;
  height: 40px;
  text-align: center;
  font-size: 14px;
  background: #036AC9 !important;
  color: #fff;
  padding: 8px;
  /* border: 1px solid #787878; */
  border-radius: 0px;
  text-decoration: none;
}

.message-template:hover {
  opacity: 0.9;
}

>>> .vue-js-switch {
  left: 1%;
}

>>> .vue-js-switch.toggled {
  background-color: #036AC9 !important;
  border-radius: 12px !important;
}

>>> .vue-js-switch.toggled .v-switch-core {
  background-color: #036AC9 !important;
  border-radius: 12px !important;
}

>>> .vue-js-switch .v-switch-button {
  border-radius: 50% !important;
}

.toggle-div {
  padding: 15px 50px;
}

.toggle-button {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-label {
  /* position: relative; */
  /* left: 10%; */
  top: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #3c3c3c;
}
</style>
